import Joi from 'joi'
import { isNil } from 'lodash'
import { Box } from '@changingai/react-editor-common-component'

import { stripQueryStringAndHashFromPath } from '@common'

export function renderPlainTextChip(chip) {
  return <Box>{chip}</Box>
}

export function renderUrlChip(chip) {
  const { error } = Joi.string()
    .uri()
    .validate(chip)
  const hasError = !isNil(error)
  return (
    <div>
      <a
        href={chip}
        target="_blank"
        style={{ color: hasError ? 'OrangeRed' : 'yellow' }}
        rel="noopener noreferrer"
      >
        {stripQueryStringAndHashFromPath(chip).substring(0, 100)}
      </a>
    </div>
  )
}
